<template>
	<div>
		<h1>Szilenciumi bejegyzések módosítása</h1>
		<v-row>
			<v-col cols="12" sm="4">
				<v-menu
          v-if="tanulo>-1"
		      v-model="hetfovalaszto.menu"
		      :close-on-content-click="false"
		      transition="scale-transition"
		      offset-y
		      min-width="290px"
		    >
		      <template v-slot:activator="{ on, attrs }">
		        <v-text-field
		          v-model="hetfovalaszto.datum"
		          label="Hét kezdőnapja"
		          prepend-inner-icon="fa-calendar"
		          readonly
		          v-bind="attrs"
		          v-on="on"
		        ></v-text-field>
		      </template>
		      <v-date-picker
		        v-model="hetfovalaszto.datum"
		        no-title
		        scrollable
						:allowed-dates="hetfok"
						first-day-of-week="1"
						@input="hetfovalaszto.menu=false, tablazatfrissitese()"
		      >
		      </v-date-picker>
		    </v-menu>
			</v-col>
			<v-col cols="12" sm="3">
        {{valasztotteleget?'OK. :)':'KÉREM VÁLASSZON MÉG SZILENCIUMOT!'}}
      </v-col>
      <v-col cols="12" sm="5">
        <v-select
          label="Tanuló"
          v-model="tanulo"
          prepend-inner-icon="fa-user"
          :items="tanulok"
          item-text="nev"
          item-value="id"
          item-disabled="nemszilenciumvalasztas"
          @change="tablazatfrissitese()">
            <template v-slot:item="{item}">
              <span :style="{backgroundColor: item.szilenciumiletszambaszamit==0&&!item.nemszilenciumvalasztas ? 'green' : item.nemszilenciumvalasztas ? 'blue' : 'transparent'}">{{item.nev+(item.csoportnev? " - "+item.csoportnev:"")+" - "+item.minositesnev}}</span>
            </template>
        </v-select>
      </v-col>
		</v-row>
		<v-data-table

			:headers="tablazat.fejlecek"
			:items="adatok.szilenciumok"
			sort-by="szam"
      hide-default-footer
      disable-pagination
		>

			<template v-slot:item.szam="{item}">
				{{item.szam}}. szilencium ({{item.idopont}})
			</template>

			<template v-slot:item.hetfo="{item}" >
        <v-tooltip top v-if="adatok.szilenciumfoglalas.findIndex(szf => szf.foglaltnap==hettetszolegesnapja(0)&&szf.foglaltszilenciumid==item.id)!=-1">
					<template v-slot:activator="{on, attrs}">
            <v-chip v-bind="attrs" v-on="on" :color="adatok.szilenciumfoglalas.find(szf => szf.foglaltnap==hettetszolegesnapja(0)&&szf.foglaltszilenciumid==item.id).foglalasmerteke==0? 'success' : (adatok.szilenciumfoglalas.find(szf => szf.foglaltnap==hettetszolegesnapja(0)&&szf.foglaltszilenciumid==item.id).foglalasmerteke==1 ? 'warning' : 'primary')">
							<v-icon left v-if="adatok.szilenciumfoglalas.find(szf => szf.foglaltnap==hettetszolegesnapja(0)&&szf.foglaltszilenciumid==item.id).jelolesnekminosulo==1">fa-check</v-icon>
              FOGLALT - {{adatok.szilenciumfoglalas.find(szf => szf.foglaltnap==hettetszolegesnapja(0)&&szf.foglaltszilenciumid==item.id).foglalasmerteke==0? 'A teljes kollégium' : (adatok.szilenciumfoglalas.find(szf => szf.foglaltnap==hettetszolegesnapja(0)&&szf.foglaltszilenciumid==item.id).foglalasmerteke==1 ? 'A teljes csoport' : 'Csak a tanuló')}}
            </v-chip>
					</template>
					<span>Foglaló: {{adatok.szilenciumfoglalas.find(szf => szf.foglaltnap==hettetszolegesnapja(0)&&szf.foglaltszilenciumid==item.id).foglalonev}}, Megjegyzés: {{adatok.szilenciumfoglalas.find(szf => szf.foglaltnap==hettetszolegesnapja(0)&&szf.foglaltszilenciumid==item.id).foglalasmegjegyzes}}</span>
				</v-tooltip>
        <div v-else>
          <v-tooltip top v-if="item.hetfo?false:(adatok.szilenciumiletszambaszamit?(adatok.szilenciumiletszam.findIndex(szl => szl.szilenciumid==item.id&&szl.nap==hettetszolegesnapja(0))==-1?false:item.letszamkorlat-adatok.szilenciumiletszam.find(szl => szl.szilenciumid==item.id&&szl.nap==hettetszolegesnapja(0)).letszam==0):false)">
            <template v-slot:activator="{on, attrs}">
              <v-chip v-bind="attrs" v-on="on" color="red">
                Megtelt
              </v-chip>
            </template>
            <span>Maximális létszám: {{item.letszamkorlat}} fő</span>
          </v-tooltip>
          <!--<v-row v-else>-->
            <!--<v-col cols="12" xs="1">--><div v-else><v-checkbox readonly v-model="item.hetfo.jeloles" :off-icon="adatok.modosithato ? '$checkboxOff' : 'fa-times'" :on-icon="adatok.modosithato ? '$checkboxOn' : 'fa-check'"  @click="bejegyzesmodositas(hettetszolegesnapja(0),item.id)"></v-checkbox></div><!--</v-col>-->
            <!--<v-col cols="12" xs="11">
              <v-text-field
                label="Megjegyzés"
                :readonly="!adatok.modosithato"
                v-if="bejegyzes(hettetszolegesnapja(0),item.id)"
                v-model="adatok.bejegyzettszilenciumok.find(bsz=> bsz.nap==hettetszolegesnapja(0)&&bsz.szilenciumid==item.id).tanuloimegjegyzes"
                v-on:change="megjegyzesmodositas(hettetszolegesnapja(0),item.id)"
              ></v-text-field>-->
            </v-col>
          <!--</v-row>-->
        </div>
			</template>
			<template v-slot:item.kedd="{item}" >
        <v-tooltip top v-if="adatok.szilenciumfoglalas.findIndex(szf => szf.foglaltnap==hettetszolegesnapja(1)&&szf.foglaltszilenciumid==item.id)!=-1">
					<template v-slot:activator="{on, attrs}">
            <v-chip v-bind="attrs" v-on="on" :color="adatok.szilenciumfoglalas.find(szf => szf.foglaltnap==hettetszolegesnapja(1)&&szf.foglaltszilenciumid==item.id).foglalasmerteke==0? 'success' : (adatok.szilenciumfoglalas.find(szf => szf.foglaltnap==hettetszolegesnapja(1)&&szf.foglaltszilenciumid==item.id).foglalasmerteke==1 ? 'warning' : 'primary')">
							<v-icon left v-if="adatok.szilenciumfoglalas.find(szf => szf.foglaltnap==hettetszolegesnapja(1)&&szf.foglaltszilenciumid==item.id).jelolesnekminosulo==1">fa-check</v-icon>
							FOGLALT - {{adatok.szilenciumfoglalas.find(szf => szf.foglaltnap==hettetszolegesnapja(1)&&szf.foglaltszilenciumid==item.id).foglalasmerteke==0? 'A teljes kollégium' : (adatok.szilenciumfoglalas.find(szf => szf.foglaltnap==hettetszolegesnapja(1)&&szf.foglaltszilenciumid==item.id).foglalasmerteke==1 ? 'A teljes csoport' : 'Csak a tanuló')}}
            </v-chip>
					</template>
					<span>Foglaló: {{adatok.szilenciumfoglalas.find(szf => szf.foglaltnap==hettetszolegesnapja(1)&&szf.foglaltszilenciumid==item.id).foglalonev}}, Megjegyzés: {{adatok.szilenciumfoglalas.find(szf => szf.foglaltnap==hettetszolegesnapja(1)&&szf.foglaltszilenciumid==item.id).foglalasmegjegyzes}}</span>
				</v-tooltip>
        <div v-else>
          <v-tooltip top v-if="item.kedd?false:(adatok.szilenciumiletszambaszamit?(adatok.szilenciumiletszam.findIndex(szl => szl.szilenciumid==item.id&&szl.nap==hettetszolegesnapja(1))==-1?false:item.letszamkorlat-adatok.szilenciumiletszam.find(szl => szl.szilenciumid==item.id&&szl.nap==hettetszolegesnapja(1)).letszam==0):false)">
            <template v-slot:activator="{on, attrs}">
              <v-chip v-bind="attrs" v-on="on" color="red">
                Megtelt
              </v-chip>
            </template>
            <span>Maximális létszám: {{item.letszamkorlat}} fő</span>
          </v-tooltip>
          <!--<v-row v-else>-->
            <!--<v-col cols="12" xs="1">--><div v-else><v-checkbox readonly v-model="item.kedd.jeloles" :off-icon="adatok.modosithato ? '$checkboxOff' : 'fa-times'" :on-icon="adatok.modosithato ? '$checkboxOn' : 'fa-check'"  @click="bejegyzesmodositas(hettetszolegesnapja(1),item.id)"></v-checkbox></div><!--</v-col>-->
            <!--<v-col cols="12" xs="11">
              <v-text-field
                label="Megjegyzés"
                :readonly="!adatok.modosithato"
                v-if="bejegyzes(hettetszolegesnapja(1),item.id)"
                v-model="adatok.bejegyzettszilenciumok.find(bsz=> bsz.nap==hettetszolegesnapja(1)&&bsz.szilenciumid==item.id).tanuloimegjegyzes"
                v-on:change="megjegyzesmodositas(hettetszolegesnapja(1),item.id)"
              ></v-text-field>
            </v-col>-->
          <!--</v-row>-->
        </div>
			</template>
			<template v-slot:item.szerda="{item}" >
        <v-tooltip top v-if="adatok.szilenciumfoglalas.findIndex(szf => szf.foglaltnap==hettetszolegesnapja(2)&&szf.foglaltszilenciumid==item.id)!=-1">
					<template v-slot:activator="{on, attrs}">
            <v-chip v-bind="attrs" v-on="on" :color="adatok.szilenciumfoglalas.find(szf => szf.foglaltnap==hettetszolegesnapja(2)&&szf.foglaltszilenciumid==item.id).foglalasmerteke==0? 'success' : (adatok.szilenciumfoglalas.find(szf => szf.foglaltnap==hettetszolegesnapja(2)&&szf.foglaltszilenciumid==item.id).foglalasmerteke==1 ? 'warning' : 'primary')">
							<v-icon left v-if="adatok.szilenciumfoglalas.find(szf => szf.foglaltnap==hettetszolegesnapja(2)&&szf.foglaltszilenciumid==item.id).jelolesnekminosulo==1">fa-check</v-icon>
							FOGLALT - {{adatok.szilenciumfoglalas.find(szf => szf.foglaltnap==hettetszolegesnapja(2)&&szf.foglaltszilenciumid==item.id).foglalasmerteke==0? 'A teljes kollégium' : (adatok.szilenciumfoglalas.find(szf => szf.foglaltnap==hettetszolegesnapja(2)&&szf.foglaltszilenciumid==item.id).foglalasmerteke==1 ? 'A teljes csoport' : 'Csak a tanuló')}}
            </v-chip>
					</template>
					<span>Foglaló: {{adatok.szilenciumfoglalas.find(szf => szf.foglaltnap==hettetszolegesnapja(2)&&szf.foglaltszilenciumid==item.id).foglalonev}}, Megjegyzés: {{adatok.szilenciumfoglalas.find(szf => szf.foglaltnap==hettetszolegesnapja(2)&&szf.foglaltszilenciumid==item.id).foglalasmegjegyzes}}</span>
				</v-tooltip>
        <div v-else>
          <v-tooltip top v-if="item.szerda?false:(adatok.szilenciumiletszambaszamit?(adatok.szilenciumiletszam.findIndex(szl => szl.szilenciumid==item.id&&szl.nap==hettetszolegesnapja(2))==-1?false:item.letszamkorlat-adatok.szilenciumiletszam.find(szl => szl.szilenciumid==item.id&&szl.nap==hettetszolegesnapja(2)).letszam==0):false)">
            <template v-slot:activator="{on, attrs}">
              <v-chip v-bind="attrs" v-on="on" color="red">
                Megtelt
              </v-chip>
            </template>
            <span>Maximális létszám: {{item.letszamkorlat}} fő</span>
          </v-tooltip>
          <!--<v-row v-else>-->
            <!--<v-col cols="12" xs="1">--><div v-else><v-checkbox readonly v-model="item.szerda.jeloles" :off-icon="adatok.modosithato ? '$checkboxOff' : 'fa-times'" :on-icon="adatok.modosithato ? '$checkboxOn' : 'fa-check'"  @click="bejegyzesmodositas(hettetszolegesnapja(2),item.id)"></v-checkbox></div><!--</v-col>-->
            <!--<v-col cols="12" xs="11">
              <v-text-field
                label="Megjegyzés"
                :readonly="!adatok.modosithato"
                v-if="bejegyzes(hettetszolegesnapja(2),item.id)"
                v-model="adatok.bejegyzettszilenciumok.find(bsz=> bsz.nap==hettetszolegesnapja(2)&&bsz.szilenciumid==item.id).tanuloimegjegyzes"
                v-on:change="megjegyzesmodositas(hettetszolegesnapja(2),item.id)"
              ></v-text-field>
            </v-col>-->
          <!--</v-row>-->
        </div>
			</template>
			<template v-slot:item.csutortok="{item}" >
        <v-tooltip top v-if="adatok.szilenciumfoglalas.findIndex(szf => szf.foglaltnap==hettetszolegesnapja(3)&&szf.foglaltszilenciumid==item.id)!=-1">
					<template v-slot:activator="{on, attrs}">
            <v-chip v-bind="attrs" v-on="on" :color="adatok.szilenciumfoglalas.find(szf => szf.foglaltnap==hettetszolegesnapja(3)&&szf.foglaltszilenciumid==item.id).foglalasmerteke==0? 'success' : (adatok.szilenciumfoglalas.find(szf => szf.foglaltnap==hettetszolegesnapja(3)&&szf.foglaltszilenciumid==item.id).foglalasmerteke==1 ? 'warning' : 'primary')">
							<v-icon left v-if="adatok.szilenciumfoglalas.find(szf => szf.foglaltnap==hettetszolegesnapja(3)&&szf.foglaltszilenciumid==item.id).jelolesnekminosulo==1">fa-check</v-icon>
							FOGLALT - {{adatok.szilenciumfoglalas.find(szf => szf.foglaltnap==hettetszolegesnapja(3)&&szf.foglaltszilenciumid==item.id).foglalasmerteke==0? 'A teljes kollégium' : (adatok.szilenciumfoglalas.find(szf => szf.foglaltnap==hettetszolegesnapja(3)&&szf.foglaltszilenciumid==item.id).foglalasmerteke==1 ? 'A teljes csoport' : 'Csak a tanuló')}}
            </v-chip>
					</template>
					<span>Foglaló: {{adatok.szilenciumfoglalas.find(szf => szf.foglaltnap==hettetszolegesnapja(3)&&szf.foglaltszilenciumid==item.id).foglalonev}}, Megjegyzés: {{adatok.szilenciumfoglalas.find(szf => szf.foglaltnap==hettetszolegesnapja(3)&&szf.foglaltszilenciumid==item.id).foglalasmegjegyzes}}</span>
				</v-tooltip>
        <div v-else>
          <v-tooltip top v-if="item.csutortok?false:(adatok.szilenciumiletszambaszamit?(adatok.szilenciumiletszam.findIndex(szl => szl.szilenciumid==item.id&&szl.nap==hettetszolegesnapja(3))==-1?false:item.letszamkorlat-adatok.szilenciumiletszam.find(szl => szl.szilenciumid==item.id&&szl.nap==hettetszolegesnapja(3)).letszam==0):false)">
            <template v-slot:activator="{on, attrs}">
              <v-chip v-bind="attrs" v-on="on" color="red">
                Megtelt
              </v-chip>
            </template>
            <span>Maximális létszám: {{item.letszamkorlat}} fő</span>
          </v-tooltip>
          <!--<v-row v-else>-->
            <!--<v-col cols="12" xs="1">--><div v-else><v-checkbox readonly v-model="item.csutortok.jeloles" :off-icon="adatok.modosithato ? '$checkboxOff' : 'fa-times'" :on-icon="adatok.modosithato ? '$checkboxOn' : 'fa-check'"  @click="bejegyzesmodositas(hettetszolegesnapja(3),item.id)"></v-checkbox></div><!--</v-col>-->
            <!--<v-col cols="12" xs="11">
              <v-text-field
                label="Megjegyzés"
                :readonly="!adatok.modosithato"
                v-if="bejegyzes(hettetszolegesnapja(3),item.id)"
                v-model="adatok.bejegyzettszilenciumok.find(bsz=> bsz.nap==hettetszolegesnapja(3)&&bsz.szilenciumid==item.id).tanuloimegjegyzes"
                v-on:change="megjegyzesmodositas(hettetszolegesnapja(3),item.id)"
              ></v-text-field>
            </v-col>-->
          <!--</v-row>-->
        </div>
			</template>

		</v-data-table>
		<v-snackbar
		 v-model="snackbar.megnyit"
		>
		 {{ snackbar.szoveg }}
		 <v-btn
			 color="pink"
			 text
			 @click="snackbar.megnyit = false"
		 >
			 Bezár
		 </v-btn>
		</v-snackbar>
	</div>
</template>

<script>
	import router from '../router';
	export default {
		data: function(){
			return {
        tanulo: -1,
				snackbar: {
					megnyit: false,
					szoveg: ""
				},
				hetfovalaszto: {
					menu: false,
					datum: this.aktualishetfo()
				},
				tablazat: {
          mutat: true,
					fejlecek: [
						{
							text: "Szilencium",
							value: "szam",
							align: "center",
							sortable: false,
							filterable: false,
							groupable: false
						},
						{
							text: "Hétfő",
							value: "hetfo",
							align: "left",
							sortable: false,
							filterable: false,
							groupable: false
						},
						{
							text: "Kedd",
							value: "kedd",
							align: "left",
							sortable: false,
							filterable: false,
							groupable: false
						},
						{
							text: "Szerda",
							value: "szerda",
							align: "left",
							sortable: false,
							filterable: false,
							groupable: false
						},
						{
							text: "Csütörtök",
							value: "csutortok",
							align: "left",
							sortable: false,
							filterable: false,
							groupable: false
						}
					]
				},
				adatok: {},
        tanulok: []
			}
		},
		computed: {
			valasztotteleget() {
				var napok = {
					hetfo: 0,
					kedd: 0,
					szerda: 0,
					csutortok: 0
				}
				var jelolesnekminosulofoglaltszilenciumok = {
					hetfo: [],
					kedd: [],
					szerda: [],
					csutortok: []
				}
				if(this.adatok.szilenciumok){
					this.adatok.szilenciumok.forEach(sz => {
						if(sz.hetfo.jeloles) napok.hetfo++;
						if(sz.kedd.jeloles) napok.kedd++;
						if(sz.szerda.jeloles) napok.szerda++;
						if(sz.csutortok.jeloles) napok.csutortok++
					})
					this.adatok.szilenciumfoglalas.filter(szf => szf.jelolesnekminosulo==1).forEach(szf => {
						switch(szf.foglaltnap) {
							case this.hettetszolegesnapja(0): if(!jelolesnekminosulofoglaltszilenciumok.hetfo.includes(szf.foglaltszilenciumid))jelolesnekminosulofoglaltszilenciumok.hetfo.push(szf.foglaltszilenciumid); break;
							case this.hettetszolegesnapja(1): if(!jelolesnekminosulofoglaltszilenciumok.kedd.includes(szf.foglaltszilenciumid))jelolesnekminosulofoglaltszilenciumok.kedd.push(szf.foglaltszilenciumid); break;
							case this.hettetszolegesnapja(2): if(!jelolesnekminosulofoglaltszilenciumok.szerda.includes(szf.foglaltszilenciumid))jelolesnekminosulofoglaltszilenciumok.szerda.push(szf.foglaltszilenciumid); break;
							case this.hettetszolegesnapja(3): if(!jelolesnekminosulofoglaltszilenciumok.csutortok.includes(szf.foglaltszilenciumid))jelolesnekminosulofoglaltszilenciumok.csutortok.push(szf.foglaltszilenciumid); break;
						}
					})
					napok.hetfo+=jelolesnekminosulofoglaltszilenciumok.hetfo.length;
					napok.kedd+=jelolesnekminosulofoglaltszilenciumok.kedd.length;
					napok.szerda+=jelolesnekminosulofoglaltszilenciumok.szerda.length;
					napok.csutortok+=jelolesnekminosulofoglaltszilenciumok.csutortok.length;
					for(var i = 0;i<4;i++) {
						const foglalhatoszilok = this.adatok.szilenciumok.length-this.adatok.szilenciumfoglalas.filter(szf => szf.foglaltnap==this.hettetszolegesnapja(i)).length
						if(foglalhatoszilok<this.adatok.valasztandoszilencium) {
							napok[((napszam) => {
								switch(napszam) {
									case 0: return 'hetfo'; break;
									case 1: return 'kedd'; break;
									case 2: return 'szerda'; break;
									case 3: return 'csutortok'; break;
								}
							})(i)] = this.adatok.valasztandoszilencium;
						}
					}

				}
				return this.adatok.szilenciumok ? napok.hetfo>=this.adatok.valasztandoszilencium && napok.kedd>=this.adatok.valasztandoszilencium &&napok.szerda>=this.adatok.valasztandoszilencium&&napok.csutortok>=this.adatok.valasztandoszilencium : false
			}
		},
		watch: {

		},
		methods: {
      megjegyzesmodositas: function(nap, szilenciumid) {
        if(!this.adatok.modosithato||new Date()<new Date(Date.parse(nap))) {
          this.snackbar.szoveg="Ez a szilencium nem módosítható."+(this.aktualishetfo()==this.hetfovalaszto.datum?" Ha a mai napnál későbbi napon van, kérjen módosítási engedélyt!":"");
          this.snackbar.megnyit=true;
        }
        else{
          this.axios.post(this.$store.state.backendeleres+"szilenciumbejegyzesek/kollegista/megjegyzes",{nap, szilenciumid, tanuloimegjegyzes: this.adatok.bejegyzettszilenciumok.find(bsz => bsz.nap==nap&&bsz.szilenciumid==szilenciumid).tanuloimegjegyzes})
                    .then((response) => {
                      if(response.data.bejelentkezve==false) this.kijelentkezes();
                      if(response.data.ok) {
                        this.snackbar.szoveg = "Sikeres módosítás";
                        this.snackbar.megnyit=true;
                      }
                      else{
                        this.snackbar.szoveg="Sikertelen módosítás: "+response.data.hiba;
                        this.snackbar.megnyit=true;
                        if(response.data.modosithato==false) this.adatok.modosithato=false
                      }
                    })
        }
      },
      bejegyzesmodositas: function(nap,szilenciumid) {
        var szilenciumvaltoztatas = (szilencium, nap, ertek) => {
          switch(new Date(Date.parse(nap)).getDay()){
            case 1:
              szilencium.hetfo.jeloles=ertek
            break;
            case 2:
              szilencium.kedd.jeloles=ertek
            break;
            case 3:
              szilencium.szerda.jeloles=ertek
            break;
            case 4:
              szilencium.csutortok.jeloles=ertek
            break;
          }
        }
        var napmeghatarozas = (nap) => {
          switch(new Date(Date.parse(nap)).getDay()){
            case 1:
                return "hetfo";
            break;
            case 2:
              return "kedd";
            break;
            case 3:
              return "szerda";
            break;
            case 4:
              return "csutortok";
            break;
          }
        }
        if(this.adatok.szilenciumok.find(sz=> sz.id==szilenciumid)[napmeghatarozas(nap)].jeloles){
          this.axios.delete(this.$store.state.backendeleres+"szilenciumbejegyzesek/nevelotanar/"+this.tanulo+"/"+nap+"/"+szilenciumid)
                    .then((response) => {
                      if(response.data.bejelentkezve==false) this.kijelentkezes();
                      if(response.data.ok) {
                        szilenciumvaltoztatas(this.adatok.szilenciumok.find(sz => sz.id==szilenciumid),nap,false)
                        this.snackbar.szoveg = "Sikeres módosítás";
                        this.snackbar.megnyit=true;
                      }
                      else{
                        this.snackbar.szoveg="Sikertelen módosítás: "+response.data.hiba;
                        this.snackbar.megnyit=true;
                      }
                    })
        }
        else{
          this.axios.post(this.$store.state.backendeleres+"szilenciumbejegyzesek/nevelotanar/bejegyzesmodositas",{nap, szilenciumid, tanuloid: this.tanulo})
                    .then((response) => {
                      if(response.data.bejelentkezve==false) this.kijelentkezes();
                      if(response.data.ok){
                        this.adatok.szilenciumok.find(sz=> sz.id==szilenciumid)[napmeghatarozas(nap)].jeloles=true
                        this.snackbar.szoveg = "Sikeres módosítás";
                        this.snackbar.megnyit=true;
                      }
                      else{
                        this.snackbar.szoveg="Sikertelen módosítás: "+response.data.hiba;
                        this.snackbar.megnyit=true;
                      }
                    })
        }
      },
			tablazatfrissitese: function() {
        return new Promise((ok,nemok) => {
          this.axios.get(this.$store.state.backendeleres+"szilenciumbejegyzesek/nevelotanar/egydiak/"+this.tanulo+"/"+this.hetfovalaszto.datum)
                    .then((response) => {
                      if(response.data.bejelentkezve==false) this.kijelentkezes();
                      if(response.data.ok){
                         this.adatok=response.data.adatok;
												 this.snackbar.szoveg = this.valasztotteleget ? 'Nem kell több szilenciumot választania! :-)': `Válasszon legalább ${this.adatok.valasztandoszilencium} szilenciumot minden napra!`
												 this.snackbar.megnyit=true;
                       }
                      ok();
                    })
        })

			},
			aktualishetfo: () => {var d = new Date(); var r = new Date(d.setDate(d.getDate()-d.getDay()+(d.getDay() == 0 ? -6:1))); return r.toISOString().substring(0,10)},
			hetfok: nap => new Date(Date.parse(nap)).getDay()==1,
			hettetszolegesnapja: function(nap /*0: hétfő, 1: kedd*/)  {
				var datum = new Date(Date.parse(this.hetfovalaszto.datum))
				datum.setDate(datum.getDate()+nap)
				return datum.toISOString().substring(0,10)
			}
		},
		mounted(){
        this.axios.get(this.$store.state.backendeleres+"szilenciumbejegyzesek/nevelotanar/tanulok").then((response) => {
          if(response.data.bejelentkezve==false) this.kijelentkezes();
          if(response.data.ok) this.tanulok=response.data.tanulok;
        })
		}
	}
</script>
